import { render, staticRenderFns } from "./select-recipients-screen.vue?vue&type=template&id=4a51f8c1&"
import script from "./select-recipients-screen.vue?vue&type=script&lang=js&"
export * from "./select-recipients-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports